module.exports = __webpack_public_path__ + "img/categorie-huitres-famille-boutrais.4c17f3a9.jpg";